"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var TextFields_1 = __importDefault(require("@material-ui/icons/TextFields"));

var Image_1 = __importDefault(require("@material-ui/icons/Image"));

var AddPhotoAlternate_1 = __importDefault(require("@material-ui/icons/AddPhotoAlternate"));

var action_row_component_1 = __importDefault(require("../action-row/action-row.component"));

var scenario_state_1 = require("../../redux/scenario/scenario.state");

var Button_1 = __importDefault(require("@material-ui/core/Button"));

var move_next_node_button_styles_1 = require("./move-next-node-button.styles");

var selectActionRow = function selectActionRow(type) {
  switch (type) {
    case scenario_state_1.ScenarioNodeType.Text:
      return react_1.default.createElement(action_row_component_1.default, {
        Icon: TextFields_1.default,
        text: "\u30C6\u30AD\u30B9\u30C8\u3075\u304D\u3060\u3057"
      });

    case scenario_state_1.ScenarioNodeType.Image:
      return react_1.default.createElement(action_row_component_1.default, {
        Icon: Image_1.default,
        text: "\u753B\u50CF\u3075\u304D\u3060\u3057"
      });

    case scenario_state_1.ScenarioNodeType.ImageExplanation:
      return react_1.default.createElement(action_row_component_1.default, {
        Icon: AddPhotoAlternate_1.default,
        text: "\u753B\u50CF\u8AAC\u660E\u3075\u304D\u3060\u3057"
      });
    //TODO GreetingScenarioNode の扱い

    default:
      throw new Error("Invalid type was given !!! type >>> ".concat(type));
  }
};

var MoveNextNodeButton = function MoveNextNodeButton(_ref) {
  var type = _ref.type,
      onClick = _ref.onClick;
  return react_1.default.createElement(move_next_node_button_styles_1.MoveNextNodeWrapperDiv, {
    onClick: onClick
  }, react_1.default.createElement(Button_1.default, null, selectActionRow(type)));
};

exports.default = MoveNextNodeButton;